import React from 'react';
import styled from '@emotion/styled';
import { Button, Typography } from 'pvs-design-system';
import { PAGE_TITLE_HEADER_TEXT_ID } from 'constants/constants';
import { Stack } from '@mui/material';
import PageTitle from 'components/PageTitle/PageTitle';
import { ArrowBack } from '@mui/icons-material';

const Container = styled.div(() => ({
  display: 'flex',
  flexDirection: 'column' as const,
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
}));

const AccessDeniedPage: React.FC = () => {
  return (
    <Container>
      <Stack
        direction="column"
        justifyContent="center"
        alignItems="center"
        spacing={2}
      >
        <PageTitle />
        <Typography
          id={PAGE_TITLE_HEADER_TEXT_ID}
          variant="h1"
          marginBottom={2}
        >
          Access Denied
        </Typography>
        <Typography variant="p-md">
          You do not have permission to view this page.
        </Typography>
        <Button
          id="button_to_home_page"
          color="primary"
          href="/"
          startIcon={<ArrowBack />}
        >
          Go to Home Page
        </Button>
      </Stack>
    </Container>
  );
};

export default AccessDeniedPage;
